import React from 'react';
//import { Link } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as artifactActions from '~/artifact/actions';
import ArtifactViewSummaryBar from '~/artifact/containers/ArtifactViewSummaryBar';
import CvssService from '~/utils/CvssService';
import Helpers from '~/utils/Helpers';
type ArtifactHeaderProps = {
  actions: object;
  artifactState: object;
  myState: object;
  searchDataState: object;
};
class ArtifactHeader extends React.Component<ArtifactHeaderProps, {}> {
  updateViewMode(mode) {
    this.props.actions.updateArtifactViewMode(mode);
  }
  submitArtifactEdits() {
    this.props.actions.submitArtifactEdits();
  }
  render() {
    const { artifactState, searchDataState } = this.props;
    const { artifact = {}, activeUrl: baseUrl = '' } = artifactState;
    const { cvss = 'cvss2' } = searchDataState;
    const {
      title = '',
      srcclrCvssScore,
      nvdCvssScore,
      nvdCvss3Score,
      srcclrCvss3Score,
      artifactComponents: components = [],
    } = artifact;
    const cvssScore =
      cvss === 'cvss2'
        ? Helpers.getFirstNonNull([nvdCvssScore, srcclrCvssScore])
        : Helpers.getFirstNonNull([nvdCvss3Score, srcclrCvss3Score]);
    const cvssVectorLevel =
      cvss === 'cvss2'
        ? CvssService.getCvssSeverity(cvssScore)
        : CvssService.getCvss3Severity(cvssScore);
    const riskColorClass = CvssService.getRiskColorClassByVectorLevel(cvssVectorLevel);
    const otherComponentsCount = components.length - 1;
    const firstComponentName = components[0] && components[0].componentName;
    return (
      <div className="grid pt">
        <div className="grid__item col-1-1">
          <div className={`${riskColorClass} bo-rad--top-5`}>
            <div className="grid ph">
              <div
                className="grid__item col-1-1"
                data-automation-id="ArtifactHeader-Summary-Header"
              >
                <h1 className="color--white font--20 font-family--body pv- mv-- antialiased phone--h4 phone--no-overflow">
                  {title} Vulnerability in the {firstComponentName} library{' '}
                  {otherComponentsCount > 0 && (
                    <span className="font--14">(+{otherComponentsCount} More)</span>
                  )}
                </h1>
              </div>
            </div>
          </div>
          <ArtifactViewSummaryBar artifact={artifact} components={components} baseUrl={baseUrl} />
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    artifactState: state.artifactState,
    myState: state.myState,
    navigationState: state.navigationState,
    routing: state.routing,
    searchDataState: state.searchDataState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(artifactActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtifactHeader);
